module.exports = __webpack_public_path__ + "static/assets/705afbafffa7a1ebcea592788ff00272.png";